export const types = {
  SET_PIRCE_STORE: 'SET_PIRCE_STORE',
}

const mutations = {
  [types.SET_PIRCE_STORE]: (state, payload) => {
    Object.assign(state, {
      ...payload,
    })
  },
}

export default mutations
